import { Reveal, Eyebrow } from "./Reveal";

const SIGN =
  "https://customer-assets-jai6qajn.emergentagent.net/job_mahadinusa-trip--80rv1i07/artifacts/f901c14724b7fc93_WhatsApp%20Image%202026-06-01%20at%2020.52.21%20%282%29.jpeg";
const CLOSET =
  "https://customer-assets-jai6qajn.emergentagent.net/job_mahadinusa-trip--80rv1i07/artifacts/e1e35f44dd0736a4_WhatsApp%20Image%202026-06-01%20at%2020.52.22.jpeg";
const DESK =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_327707c4-c57f-40e3-bfb7-c75b023b7589/artifacts/82024c23a725202e_WhatsApp%20Image%202026-06-01%20at%2020.52.20%20%281%29.jpeg";

export const Story = () => (
  <section id="story" data-testid="story-section" className="py-20 sm:py-28">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-8">
        <div className="lg:col-span-5">
          <Reveal>
            <Eyebrow>Our Story</Eyebrow>
            <h2 className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-snug text-balance">
              A small house by the sea, kept the slow way
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-base sm:text-lg text-seastone leading-relaxed">
              Mahadinusa began as a family escape on Nusa Lembongan — a place where days are measured in tides,
              not hours. Behind the carved wooden sign you will find garden rooms dressed in white linen and warm
              timber, and a pool shaded by a flowering tree that drops pink blossoms on the water.
            </p>
            <p className="mt-4 text-base sm:text-lg text-seastone leading-relaxed">
              Jungutbatu keeps you close to everything that matters: the beach is a few minutes on foot, the
              mangrove forests lie just north, and the fast boats from Sanur reach the island in about thirty
              minutes — no car ferry, no queues, just sea air.
            </p>
            <blockquote className="mt-8 border-l-2 border-gold pl-5 font-serif italic text-lg text-ink/80">
              "Mahadinusa" — maha, great; nusa, island. The great little island that looks after you.
            </blockquote>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-10 flex gap-10">
              <div>
                <p className="font-serif text-4xl" data-testid="story-stat-rooms">4</p>
                <p className="text-xs font-mono uppercase tracking-[0.2em] text-seastone mt-1">Ways to stay</p>
              </div>
              <div>
                <p className="font-serif text-4xl" data-testid="story-stat-crossing">30<span className="text-2xl">min</span></p>
                <p className="text-xs font-mono uppercase tracking-[0.2em] text-seastone mt-1">From Sanur</p>
              </div>
              <div>
                <p className="font-serif text-4xl" data-testid="story-stat-host">1</p>
                <p className="text-xs font-mono uppercase tracking-[0.2em] text-seastone mt-1">Island host</p>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7 grid grid-cols-12 gap-4 items-start">
          <Reveal className="col-span-7" delay={0.05}>
            <img
              src={SIGN}
              alt="Carved wooden Mahadinusa sign at the entrance, guests on the terrace behind"
              className="rounded-3xl w-full h-64 sm:h-96 object-cover shadow-[0_20px_60px_rgba(14,27,46,0.15)]"
              data-testid="story-image-sign"
            />
          </Reveal>
          <Reveal className="col-span-5 pt-10 sm:pt-20" delay={0.15}>
            <img
              src={CLOSET}
              alt="Teak shelves with rolled towels and ceramic bowls inside a Mahadinusa room"
              className="rounded-3xl w-full h-52 sm:h-72 object-cover shadow-[0_20px_60px_rgba(14,27,46,0.15)]"
              data-testid="story-image-closet"
            />
          </Reveal>
          <Reveal className="col-span-12 sm:col-span-8 sm:col-start-3" delay={0.1}>
            <div className="relative">
              <img
                src={DESK}
                alt="Room work desk of island timber with garden view at Mahadinusa"
                className="rounded-3xl w-full h-56 sm:h-72 object-cover"
                data-testid="story-image-desk"
              />
              <p className="absolute -bottom-4 left-6 bg-ink text-sand text-[10px] font-mono uppercase tracking-[0.25em] px-4 py-2 rounded-full">
                Every room faces the green
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
